<!--suppress HtmlUnknownTarget -->
<template>
  <div class="[ c-cookie-banner__logo ]" v-if="imagePath">
    <SimpleSVG v-if="isSvg" :src="imagePath" custom-class-name="c-cookie-banner__logo"></SimpleSVG>
    <img v-else :src="imagePath" class="c-cookie-banner__logo" alt="logo">
  </div>
</template>

<script>
import { SimpleSVG } from 'vue-simple-svg'

export default {
  name: 'Logo',
  components: {
    SimpleSVG
  },
  props: {
    imagePath: String
  },
  computed: {
    isSvg: function () {
      return /\.sv?g$/i.test(this.imagePath)
    }
  }
}
</script>
